
    import './styles.scoped.css';
    export default {
  "box": "awsui_box_18wu0_9nh0q_24",
  "p-variant": "awsui_p-variant_18wu0_9nh0q_24",
  "color-default": "awsui_color-default_18wu0_9nh0q_24",
  "b-variant": "awsui_b-variant_18wu0_9nh0q_24",
  "strong-variant": "awsui_strong-variant_18wu0_9nh0q_24",
  "code-variant": "awsui_code-variant_18wu0_9nh0q_24",
  "pre-variant": "awsui_pre-variant_18wu0_9nh0q_24",
  "samp-variant": "awsui_samp-variant_18wu0_9nh0q_24",
  "h1-variant": "awsui_h1-variant_18wu0_9nh0q_28",
  "h2-variant": "awsui_h2-variant_18wu0_9nh0q_28",
  "h3-variant": "awsui_h3-variant_18wu0_9nh0q_28",
  "h4-variant": "awsui_h4-variant_18wu0_9nh0q_28",
  "h5-variant": "awsui_h5-variant_18wu0_9nh0q_28",
  "small-variant": "awsui_small-variant_18wu0_9nh0q_32",
  "a-variant": "awsui_a-variant_18wu0_9nh0q_36",
  "font-size-default": "awsui_font-size-default_18wu0_9nh0q_40",
  "font-weight-default": "awsui_font-weight-default_18wu0_9nh0q_81",
  "key-label-variant": "awsui_key-label-variant_18wu0_9nh0q_123",
  "gen-ai-label-variant": "awsui_gen-ai-label-variant_18wu0_9nh0q_130",
  "value-large-variant": "awsui_value-large-variant_18wu0_9nh0q_137",
  "inline-code-variant": "awsui_inline-code-variant_18wu0_9nh0q_147",
  "font-weight-heavy": "awsui_font-weight-heavy_18wu0_9nh0q_161",
  "color-inverted": "awsui_color-inverted_18wu0_9nh0q_166",
  "color-text-label": "awsui_color-text-label_18wu0_9nh0q_169",
  "color-text-body-secondary": "awsui_color-text-body-secondary_18wu0_9nh0q_172",
  "color-text-status-error": "awsui_color-text-status-error_18wu0_9nh0q_175",
  "color-text-status-success": "awsui_color-text-status-success_18wu0_9nh0q_178",
  "color-text-status-info": "awsui_color-text-status-info_18wu0_9nh0q_181",
  "color-text-status-inactive": "awsui_color-text-status-inactive_18wu0_9nh0q_184",
  "color-text-status-warning": "awsui_color-text-status-warning_18wu0_9nh0q_187",
  "color-inherit": "awsui_color-inherit_18wu0_9nh0q_190",
  "font-size-body-s": "awsui_font-size-body-s_18wu0_9nh0q_193",
  "font-size-body-m": "awsui_font-size-body-m_18wu0_9nh0q_198",
  "font-size-heading-xs": "awsui_font-size-heading-xs_18wu0_9nh0q_202",
  "font-size-heading-s": "awsui_font-size-heading-s_18wu0_9nh0q_207",
  "font-size-heading-m": "awsui_font-size-heading-m_18wu0_9nh0q_212",
  "font-size-heading-l": "awsui_font-size-heading-l_18wu0_9nh0q_217",
  "font-size-heading-xl": "awsui_font-size-heading-xl_18wu0_9nh0q_222",
  "font-size-display-l": "awsui_font-size-display-l_18wu0_9nh0q_227",
  "font-size-display-xl": "awsui_font-size-display-xl_18wu0_9nh0q_232",
  "font-weight-light": "awsui_font-weight-light_18wu0_9nh0q_237",
  "font-weight-normal": "awsui_font-weight-normal_18wu0_9nh0q_240",
  "font-weight-bold": "awsui_font-weight-bold_18wu0_9nh0q_243",
  "t-left": "awsui_t-left_18wu0_9nh0q_250",
  "t-right": "awsui_t-right_18wu0_9nh0q_254",
  "t-center": "awsui_t-center_18wu0_9nh0q_258",
  "p-n": "awsui_p-n_18wu0_9nh0q_267",
  "p-top-n": "awsui_p-top-n_18wu0_9nh0q_272",
  "p-vertical-n": "awsui_p-vertical-n_18wu0_9nh0q_273",
  "p-right-n": "awsui_p-right-n_18wu0_9nh0q_277",
  "p-horizontal-n": "awsui_p-horizontal-n_18wu0_9nh0q_278",
  "p-bottom-n": "awsui_p-bottom-n_18wu0_9nh0q_282",
  "p-left-n": "awsui_p-left-n_18wu0_9nh0q_287",
  "p-xxxs": "awsui_p-xxxs_18wu0_9nh0q_292",
  "p-top-xxxs": "awsui_p-top-xxxs_18wu0_9nh0q_297",
  "p-vertical-xxxs": "awsui_p-vertical-xxxs_18wu0_9nh0q_298",
  "p-right-xxxs": "awsui_p-right-xxxs_18wu0_9nh0q_302",
  "p-horizontal-xxxs": "awsui_p-horizontal-xxxs_18wu0_9nh0q_303",
  "p-bottom-xxxs": "awsui_p-bottom-xxxs_18wu0_9nh0q_307",
  "p-left-xxxs": "awsui_p-left-xxxs_18wu0_9nh0q_312",
  "p-xxs": "awsui_p-xxs_18wu0_9nh0q_317",
  "p-top-xxs": "awsui_p-top-xxs_18wu0_9nh0q_322",
  "p-vertical-xxs": "awsui_p-vertical-xxs_18wu0_9nh0q_323",
  "p-right-xxs": "awsui_p-right-xxs_18wu0_9nh0q_327",
  "p-horizontal-xxs": "awsui_p-horizontal-xxs_18wu0_9nh0q_328",
  "p-bottom-xxs": "awsui_p-bottom-xxs_18wu0_9nh0q_332",
  "p-left-xxs": "awsui_p-left-xxs_18wu0_9nh0q_337",
  "p-xs": "awsui_p-xs_18wu0_9nh0q_342",
  "p-top-xs": "awsui_p-top-xs_18wu0_9nh0q_347",
  "p-vertical-xs": "awsui_p-vertical-xs_18wu0_9nh0q_348",
  "p-right-xs": "awsui_p-right-xs_18wu0_9nh0q_352",
  "p-horizontal-xs": "awsui_p-horizontal-xs_18wu0_9nh0q_353",
  "p-bottom-xs": "awsui_p-bottom-xs_18wu0_9nh0q_357",
  "p-left-xs": "awsui_p-left-xs_18wu0_9nh0q_362",
  "p-s": "awsui_p-s_18wu0_9nh0q_367",
  "p-top-s": "awsui_p-top-s_18wu0_9nh0q_372",
  "p-vertical-s": "awsui_p-vertical-s_18wu0_9nh0q_373",
  "p-right-s": "awsui_p-right-s_18wu0_9nh0q_377",
  "p-horizontal-s": "awsui_p-horizontal-s_18wu0_9nh0q_378",
  "p-bottom-s": "awsui_p-bottom-s_18wu0_9nh0q_382",
  "p-left-s": "awsui_p-left-s_18wu0_9nh0q_387",
  "p-m": "awsui_p-m_18wu0_9nh0q_392",
  "p-top-m": "awsui_p-top-m_18wu0_9nh0q_397",
  "p-vertical-m": "awsui_p-vertical-m_18wu0_9nh0q_398",
  "p-right-m": "awsui_p-right-m_18wu0_9nh0q_402",
  "p-horizontal-m": "awsui_p-horizontal-m_18wu0_9nh0q_403",
  "p-bottom-m": "awsui_p-bottom-m_18wu0_9nh0q_407",
  "p-left-m": "awsui_p-left-m_18wu0_9nh0q_412",
  "p-l": "awsui_p-l_18wu0_9nh0q_287",
  "p-top-l": "awsui_p-top-l_18wu0_9nh0q_422",
  "p-vertical-l": "awsui_p-vertical-l_18wu0_9nh0q_423",
  "p-right-l": "awsui_p-right-l_18wu0_9nh0q_427",
  "p-horizontal-l": "awsui_p-horizontal-l_18wu0_9nh0q_428",
  "p-bottom-l": "awsui_p-bottom-l_18wu0_9nh0q_432",
  "p-left-l": "awsui_p-left-l_18wu0_9nh0q_437",
  "p-xl": "awsui_p-xl_18wu0_9nh0q_442",
  "p-top-xl": "awsui_p-top-xl_18wu0_9nh0q_447",
  "p-vertical-xl": "awsui_p-vertical-xl_18wu0_9nh0q_448",
  "p-right-xl": "awsui_p-right-xl_18wu0_9nh0q_452",
  "p-horizontal-xl": "awsui_p-horizontal-xl_18wu0_9nh0q_453",
  "p-bottom-xl": "awsui_p-bottom-xl_18wu0_9nh0q_457",
  "p-left-xl": "awsui_p-left-xl_18wu0_9nh0q_462",
  "p-xxl": "awsui_p-xxl_18wu0_9nh0q_467",
  "p-top-xxl": "awsui_p-top-xxl_18wu0_9nh0q_472",
  "p-vertical-xxl": "awsui_p-vertical-xxl_18wu0_9nh0q_473",
  "p-right-xxl": "awsui_p-right-xxl_18wu0_9nh0q_477",
  "p-horizontal-xxl": "awsui_p-horizontal-xxl_18wu0_9nh0q_478",
  "p-bottom-xxl": "awsui_p-bottom-xxl_18wu0_9nh0q_482",
  "p-left-xxl": "awsui_p-left-xxl_18wu0_9nh0q_487",
  "p-xxxl": "awsui_p-xxxl_18wu0_9nh0q_492",
  "p-top-xxxl": "awsui_p-top-xxxl_18wu0_9nh0q_497",
  "p-vertical-xxxl": "awsui_p-vertical-xxxl_18wu0_9nh0q_498",
  "p-right-xxxl": "awsui_p-right-xxxl_18wu0_9nh0q_502",
  "p-horizontal-xxxl": "awsui_p-horizontal-xxxl_18wu0_9nh0q_503",
  "p-bottom-xxxl": "awsui_p-bottom-xxxl_18wu0_9nh0q_507",
  "p-left-xxxl": "awsui_p-left-xxxl_18wu0_9nh0q_512",
  "m-n": "awsui_m-n_18wu0_9nh0q_517",
  "m-top-n": "awsui_m-top-n_18wu0_9nh0q_522",
  "m-vertical-n": "awsui_m-vertical-n_18wu0_9nh0q_523",
  "m-right-n": "awsui_m-right-n_18wu0_9nh0q_527",
  "m-horizontal-n": "awsui_m-horizontal-n_18wu0_9nh0q_528",
  "m-bottom-n": "awsui_m-bottom-n_18wu0_9nh0q_532",
  "m-left-n": "awsui_m-left-n_18wu0_9nh0q_537",
  "m-xxxs": "awsui_m-xxxs_18wu0_9nh0q_542",
  "m-top-xxxs": "awsui_m-top-xxxs_18wu0_9nh0q_547",
  "m-vertical-xxxs": "awsui_m-vertical-xxxs_18wu0_9nh0q_548",
  "m-right-xxxs": "awsui_m-right-xxxs_18wu0_9nh0q_552",
  "m-horizontal-xxxs": "awsui_m-horizontal-xxxs_18wu0_9nh0q_553",
  "m-bottom-xxxs": "awsui_m-bottom-xxxs_18wu0_9nh0q_557",
  "m-left-xxxs": "awsui_m-left-xxxs_18wu0_9nh0q_562",
  "m-xxs": "awsui_m-xxs_18wu0_9nh0q_567",
  "m-top-xxs": "awsui_m-top-xxs_18wu0_9nh0q_572",
  "m-vertical-xxs": "awsui_m-vertical-xxs_18wu0_9nh0q_573",
  "m-right-xxs": "awsui_m-right-xxs_18wu0_9nh0q_577",
  "m-horizontal-xxs": "awsui_m-horizontal-xxs_18wu0_9nh0q_578",
  "m-bottom-xxs": "awsui_m-bottom-xxs_18wu0_9nh0q_582",
  "m-left-xxs": "awsui_m-left-xxs_18wu0_9nh0q_587",
  "m-xs": "awsui_m-xs_18wu0_9nh0q_592",
  "m-top-xs": "awsui_m-top-xs_18wu0_9nh0q_597",
  "m-vertical-xs": "awsui_m-vertical-xs_18wu0_9nh0q_598",
  "m-right-xs": "awsui_m-right-xs_18wu0_9nh0q_602",
  "m-horizontal-xs": "awsui_m-horizontal-xs_18wu0_9nh0q_603",
  "m-bottom-xs": "awsui_m-bottom-xs_18wu0_9nh0q_607",
  "m-left-xs": "awsui_m-left-xs_18wu0_9nh0q_612",
  "m-s": "awsui_m-s_18wu0_9nh0q_617",
  "m-top-s": "awsui_m-top-s_18wu0_9nh0q_622",
  "m-vertical-s": "awsui_m-vertical-s_18wu0_9nh0q_623",
  "m-right-s": "awsui_m-right-s_18wu0_9nh0q_627",
  "m-horizontal-s": "awsui_m-horizontal-s_18wu0_9nh0q_628",
  "m-bottom-s": "awsui_m-bottom-s_18wu0_9nh0q_632",
  "m-left-s": "awsui_m-left-s_18wu0_9nh0q_637",
  "m-m": "awsui_m-m_18wu0_9nh0q_642",
  "m-top-m": "awsui_m-top-m_18wu0_9nh0q_647",
  "m-vertical-m": "awsui_m-vertical-m_18wu0_9nh0q_648",
  "m-right-m": "awsui_m-right-m_18wu0_9nh0q_652",
  "m-horizontal-m": "awsui_m-horizontal-m_18wu0_9nh0q_653",
  "m-bottom-m": "awsui_m-bottom-m_18wu0_9nh0q_657",
  "m-left-m": "awsui_m-left-m_18wu0_9nh0q_662",
  "m-l": "awsui_m-l_18wu0_9nh0q_537",
  "m-top-l": "awsui_m-top-l_18wu0_9nh0q_672",
  "m-vertical-l": "awsui_m-vertical-l_18wu0_9nh0q_673",
  "m-right-l": "awsui_m-right-l_18wu0_9nh0q_677",
  "m-horizontal-l": "awsui_m-horizontal-l_18wu0_9nh0q_678",
  "m-bottom-l": "awsui_m-bottom-l_18wu0_9nh0q_682",
  "m-left-l": "awsui_m-left-l_18wu0_9nh0q_687",
  "m-xl": "awsui_m-xl_18wu0_9nh0q_692",
  "m-top-xl": "awsui_m-top-xl_18wu0_9nh0q_697",
  "m-vertical-xl": "awsui_m-vertical-xl_18wu0_9nh0q_698",
  "m-right-xl": "awsui_m-right-xl_18wu0_9nh0q_702",
  "m-horizontal-xl": "awsui_m-horizontal-xl_18wu0_9nh0q_703",
  "m-bottom-xl": "awsui_m-bottom-xl_18wu0_9nh0q_707",
  "m-left-xl": "awsui_m-left-xl_18wu0_9nh0q_712",
  "m-xxl": "awsui_m-xxl_18wu0_9nh0q_717",
  "m-top-xxl": "awsui_m-top-xxl_18wu0_9nh0q_722",
  "m-vertical-xxl": "awsui_m-vertical-xxl_18wu0_9nh0q_723",
  "m-right-xxl": "awsui_m-right-xxl_18wu0_9nh0q_727",
  "m-horizontal-xxl": "awsui_m-horizontal-xxl_18wu0_9nh0q_728",
  "m-bottom-xxl": "awsui_m-bottom-xxl_18wu0_9nh0q_732",
  "m-left-xxl": "awsui_m-left-xxl_18wu0_9nh0q_737",
  "m-xxxl": "awsui_m-xxxl_18wu0_9nh0q_742",
  "m-top-xxxl": "awsui_m-top-xxxl_18wu0_9nh0q_747",
  "m-vertical-xxxl": "awsui_m-vertical-xxxl_18wu0_9nh0q_748",
  "m-right-xxxl": "awsui_m-right-xxxl_18wu0_9nh0q_752",
  "m-horizontal-xxxl": "awsui_m-horizontal-xxxl_18wu0_9nh0q_753",
  "m-bottom-xxxl": "awsui_m-bottom-xxxl_18wu0_9nh0q_757",
  "m-left-xxxl": "awsui_m-left-xxxl_18wu0_9nh0q_762",
  "d-block": "awsui_d-block_18wu0_9nh0q_767",
  "d-inline": "awsui_d-inline_18wu0_9nh0q_770",
  "d-inline-block": "awsui_d-inline-block_18wu0_9nh0q_773",
  "d-none": "awsui_d-none_18wu0_9nh0q_776",
  "f-left": "awsui_f-left_18wu0_9nh0q_780",
  "f-right": "awsui_f-right_18wu0_9nh0q_784",
  "visual-accent": "awsui_visual-accent_18wu0_9nh0q_788",
  "visual-accent-radius-xxxs": "awsui_visual-accent-radius-xxxs_18wu0_9nh0q_797",
  "visual-accent-radius-xxs": "awsui_visual-accent-radius-xxs_18wu0_9nh0q_804",
  "visual-accent-radius-xs": "awsui_visual-accent-radius-xs_18wu0_9nh0q_811",
  "visual-accent-radius-s": "awsui_visual-accent-radius-s_18wu0_9nh0q_818",
  "visual-accent-radius-m": "awsui_visual-accent-radius-m_18wu0_9nh0q_825",
  "visual-accent-radius-l": "awsui_visual-accent-radius-l_18wu0_9nh0q_832",
  "visual-accent-radius-xl": "awsui_visual-accent-radius-xl_18wu0_9nh0q_839",
  "visual-accent-radius-xxl": "awsui_visual-accent-radius-xxl_18wu0_9nh0q_846",
  "visual-accent-radius-xxxl": "awsui_visual-accent-radius-xxxl_18wu0_9nh0q_853",
  "visual-accent-radius-full": "awsui_visual-accent-radius-full_18wu0_9nh0q_860",
  "visual-accent-aspect-auto": "awsui_visual-accent-aspect-auto_18wu0_9nh0q_867",
  "visual-accent-aspect-equal": "awsui_visual-accent-aspect-equal_18wu0_9nh0q_872",
  "visual-accent-red": "awsui_visual-accent-red_18wu0_9nh0q_880",
  "visual-accent-yellow": "awsui_visual-accent-yellow_18wu0_9nh0q_885",
  "visual-accent-indigo": "awsui_visual-accent-indigo_18wu0_9nh0q_890",
  "visual-accent-green": "awsui_visual-accent-green_18wu0_9nh0q_895",
  "visual-accent-orange": "awsui_visual-accent-orange_18wu0_9nh0q_900",
  "visual-accent-purple": "awsui_visual-accent-purple_18wu0_9nh0q_905",
  "visual-accent-grey": "awsui_visual-accent-grey_18wu0_9nh0q_910",
  "visual-accent-teal": "awsui_visual-accent-teal_18wu0_9nh0q_915",
  "root": "awsui_root_18wu0_9nh0q_920"
};
  